export default __webpack_public_path__ + "static/media/ua.8a140163.svg";